import { tr } from "../../i18n";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
export const inputCls = "w-full border border-esaia-line bg-white px-3 py-2.5 text-sm text-esaia-ink placeholder:text-esaia-subtle focus:border-esaia-blue focus:outline-none";
export const Field = ({
  label,
  htmlFor,
  required,
  children
}) => <div>
    <label htmlFor={htmlFor} className="mb-1.5 block text-xs font-medium text-esaia-ink">
      {label} {required && <span className="text-esaia-blue">*</span>}
    </label>
    {children}
  </div>;
export const ErrorNote = ({
  error
}) => error ? <p role="alert" className="border border-red-600/30 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="auth-error">
      {error}
    </p> : null;
export default function AuthLayout({
  title,
  subtitle,
  children
}) {
  const {
    lang = "en"
  } = useParams();
  return <div className="flex min-h-screen flex-col bg-esaia-canvas hairline-grid">
      <div className="border-b border-esaia-line bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
          <Link to={`/${lang}`} aria-label={tr("ESAIA home")}>
            <img src="/logo.png" alt={tr("ESAIA")} className="h-9 w-auto" />
          </Link>
          <Link to={`/${lang}`} className="inline-flex items-center gap-2 text-xs font-semibold text-esaia-muted transition-colors hover:text-esaia-blue">
            <ArrowLeft size={14} />{" "}{tr("Back to website")}{" "}</Link>
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center px-4 py-14">
        <div className="w-full max-w-md">
          <div className="border border-esaia-line bg-white p-8 sm:p-10" data-testid="auth-card">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-esaia-blue">{tr("ESAIA Portal")}</p>
            <h1 className="mt-3 text-2xl font-semibold tracking-tight text-esaia-ink">{title}</h1>
            {subtitle && <p className="mt-2 text-sm leading-relaxed text-esaia-muted">{subtitle}</p>}
            <div className="mt-7">{children}</div>
          </div>
          <p className="mt-6 text-center font-serif text-sm font-light italic text-esaia-blue/70">{tr("Transparent. Accountable. Ethical.")}{" "}</p>
        </div>
      </div>
    </div>;
}
